<script>
    let open = false;

    export let question = "";
    export let answer = "";
    export let id;
    let accordionElement;
</script>

<div  on:click={() => {
            open = !open;
        }}
        on:keydown class="svelte-accordion {open ? 'open' : ''}" {id} bind:this={accordionElement}>
    <div
        class="accordion-question-container"
        
    >
        <div class="accordion-question">
            <span>{question}</span>

            <svg
                width="14"
                height="8"
                viewBox="0 0 14 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    id="Vector"
                    d="M12.8558 1.53304e-07L14 1.1898L7.76423 7.67036C7.66431 7.77483 7.54549 7.85773 7.41461 7.9143C7.28373 7.97088 7.14337 8 7.00162 8C6.85986 8 6.71951 7.97088 6.58863 7.9143C6.45775 7.85773 6.33893 7.77483 6.23901 7.67036L8.12108e-08 1.1898L1.14418 0.00112153L7 6.08359L12.8558 1.53304e-07Z"
                    fill="#4DCEBD"
                />
            </svg>
        </div>
    </div>
        <div class="accordion-answer" >
            <div itemprop="text">{@html answer}</div>
        </div>
</div>
